export const DEFAULT_MODAL_OPACITY = '0.9';
export const DEFAULT_MODAL_OVERLAY_COLOR = '#000000';
